export default __webpack_public_path__ + "static/media/joker_used.32aacf11.svg";